export const baseFindValByKeyInObject = (obj: object, keyToFind: string) => {
  if (obj[keyToFind] !== undefined && obj[keyToFind]) { return obj[keyToFind] }

  for (const key in obj) {
    if (obj[key] instanceof Object) {
      const value = baseFindValByKeyInObject(obj[key], keyToFind)
      if (value) { return value }
    }
  }

  return null
}
